<script>
import api from '@utils/api'
import { cloneDeep } from 'lodash'

export default {
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    headers: {
      type: Array,
      default: null,
    },
    modelName: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      includeAll: false,
      on: {},
      columns: [],
    }
  },
  computed: {
    showDialog: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
  mounted() {
    this.columns = cloneDeep(this.headers)
    api.getColumnsToDisplay(this.modelName).then(columns => {
      for (let key of Object.keys(columns)) {
        let header = this.columns.find(h => h.text === key)
        if (header) {
          header.show = columns[key]
        }
      }
      this.$emit('columns-updated', this.columns)
    })
  },
  methods: {
    includeAllColumns() {
      for (let field of this.columns) {
        field.show = true
        this.apply()
      }
    },
    apply() {
      this.showDialog = false
      this.updateColumns()
    },
    updateColumns() {
      var result = {}
      for (let column of this.columns) {
        result[column.text] = column.show
      }
      api.updateColumnsToDisplay(this.modelName, result).then(() => {
        this.$emit('columns-updated', this.columns)
      })
    },
  },
}
</script>
<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="showDialog"
      width="500"
    >
      <v-card>
        <v-card-title>
          <v-spacer />
          <div class="headline">{{ $t('titles__columns') }}</div>
          <v-spacer />
        </v-card-title>
        <v-card-text>
          <v-container
            fluid
            grid-list-md
          >
            <v-layout wrap>
              <v-flex
                xs12
                class="text-xs-center"
              >
                <v-checkbox 
                  v-for="field in columns"
                  v-model="field.show"
                  :key="field.value"
                  :label="$t(`label__` + field.text)"
                />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            block
            @click="showDialog = false"
          >
            {{ $t('buttons__close') }}
          </v-btn>
          <v-btn
            color="secondary"
            block
            @click="includeAllColumns()"
          >
            {{ $t('buttons__show_all') }}
          </v-btn>
          <v-btn
            color="primary"
            block
            @click="apply()"
          >
            {{ $t('buttons__apply') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
